import { Breadcrumbs, Typography, Link } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { usePrincipalObrasViewModel } from "../../viewModels/principal_obras_view_model";

import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import PrincipaisDocGrid from "../../../../../common/components/principaisDocGrid";
import StatCard from "../../../../../common/components/statCard";
import { Check, Construction, Warning } from "@mui/icons-material";

/**
 * PrincipalObras
 */

export const PrincipalObras = () => {
  const viewModel = usePrincipalObrasViewModel();
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[10rem]">
              </div>
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Typography className="text-primary-green">
            Principal Obras
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <div className="flex gap-2 items-center w-full">
            <h1 className="text-3xl font-medium text-black dark:text-white">Principal Obras</h1>
            <RefreshButton onClick={viewModel.handleReload} />
          </div>

          <div className="w-full justify-end flex gap-2"></div>
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                {
                  viewModel.dashboardObrasInformation !== null && (
                    <div className="w-full flex flex-col gap-4 mb-8">
                      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
                        <StatCard
                          title='Equipamentos Calibrados'
                          value={viewModel.dashboardObrasInformation.equipamentosCalibrados}
                          icon={Construction}
                          colorClass={{
                            bg: 'bg-amber-500',
                            text: 'text-white',
                            bgHover: 'bg-amber-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('equipamentosCalibrados')}
                        />

                        <StatCard
                          title='Equipamentos Verificados'
                          value={viewModel.dashboardObrasInformation.equipamentosVerificados}
                          icon={Check}
                          colorClass={{
                            bg: 'bg-teal-500',
                            text: 'text-white',
                            bgHover: 'bg-teal-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('equipamentosVerificados')}
                        />

                        <StatCard
                          title='Equipamentos Em Atraso'
                          value={viewModel.dashboardObrasInformation.equipamentosEmAtraso}
                          icon={Warning}
                          colorClass={{
                            bg: 'bg-red-500',
                            text: 'text-white',
                            bgHover: 'bg-red-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('equipamentosEmAtraso')}
                        />

                        <StatCard
                          title='Documento Vencidos'
                          value={viewModel.dashboardObrasInformation.documentosVencidos}
                          icon={Warning}
                          colorClass={{
                            bg: 'bg-red-500',
                            text: 'text-white',
                            bgHover: 'bg-red-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('documentosVencidos')}
                        />

                        <StatCard
                          title='Equipamentos Locados Em Atraso'
                          value={viewModel.dashboardObrasInformation.equipamentosLocadosEmAtraso}
                          icon={Warning}
                          colorClass={{
                            bg: 'bg-red-500',
                            text: 'text-white',
                            bgHover: 'bg-red-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('equipamentosLocadosEmAtraso')}
                        />

                        <StatCard
                          title='Resultado Concretagem Pendente de registro'
                          value={viewModel.dashboardObrasInformation.resultadoConcretagemPendenteRegistro}
                          icon={Warning}
                          colorClass={{
                            bg: 'bg-red-500',
                            text: 'text-white',
                            bgHover: 'bg-red-600',
                          }}
                          linkText='Ver detalhes'
                          onClick={() => viewModel.handleCardClick('resultadoConcretagemPendenteRegistro')}
                        />
                      </div>

                      <PrincipaisDocGrid
                        loading={viewModel.loading}
                        rows={viewModel.docLista}
                        totalItems={viewModel.pagination.totalItems}
                        page={viewModel.pagination.page}
                        rowsPerPage={viewModel.pagination.rowsPerPage}
                        onPageChange={(p) => viewModel.handlePageChange(p)}
                        onRowsPerPageChange={(p) => viewModel.handleRowsPerPageChange(p)}
                        onActionExportar={(IdArquivoModulo, NomeArquivo) =>
                          viewModel.handleDownloadFile(IdArquivoModulo, NomeArquivo)
                        }
                      />
                    </div>
                  )
                }
              </>
            )
        }
      </div>
    </>
  );
}